import getLabel from '../getLabels'

export const isSeatCountValid = (value, allValue, props, fieldName) => {
  const isNoValidNumber = value === 0
  const isNotNumber = value === 'e' || value === 'E'

  if (isNoValidNumber || isNotNumber) {
    return getLabel('invalid_seat_count_selected')
  }

  if (!value) {
    return undefined
  }

  const maxValue = props.searchResults.find(flight =>
    flight.flightId.includes(fieldName.split('.')[0])
  ).availableSeatCount

  return parseInt(value) <= maxValue
    ? undefined
    : getLabel('invalid_seat_count_selected')
}
